export default __webpack_public_path__ + "static/media/avatar-3.8f3b1069.jpg";